<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group label="Nome" label-for="v-name">
                <b-form-input
                  id="v-name"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="nome"
                  data-cy="nome-input"
                  :disabled="!canEditOrInsert"
                />
                <small data-cy="v-nome-validate" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col v-if="form.id" cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="form.ativo"
                :checked="form.ativo"
                name="check-button"
                switch
                inline
                data-cy="ativo-checkbox"
                :disabled="!canEditOrInsert"
              >
                {{ form.ativo ? "Sim" : "Não" }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="canInsert"
            :permission-edit="canEdit"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import mixinsGlobal from "@/mixins";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState("grupoSettingsModule", {
      grupo: (state) => state.grupo,
    }),
    canInsert() {
      return this.verificarPermissao("ROLE_GRUPO_PROCEDIMENTO_INSERIR");
    },
    canEdit() {
      return this.verificarPermissao("ROLE_GRUPO_PROCEDIMENTO_ALTERAR");
    },
    canEditOrInsert() {
      if (this.form.id) {
        return this.canEdit;
      }
      return this.canInsert;
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      titleForm: "Cadastro de Grupo",
      required,
      form: {
        nome: "",
        ativo: true,
      },
    };
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.grupo));
  },
  methods: {
    cancel() {
      this.$emit("cancelar");
      this.cleanObjeto();
      this.$store.dispatch("grupoSettingsModule/reset");
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch("grupoSettingsModule/edit", this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Editar",
                    response.response.data.error,
                  );
                  return;
                }
                this.showMessageSuccess("Editar", "Editado com sucesso!");
                this.$refs.form.reset();
                this.cancel();
              });
          } else {
            this.$store
              .dispatch("grupoSettingsModule/insert", this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    "Falha ao Inserir",
                    response.response.data.error,
                  );
                  return;
                }
                this.showMessageSuccess("Salvo", "Incluido com sucesso!");
                this.cleanObjeto();
                this.$refs.form.reset();
              });
          }
        }
      });
    },
    cleanObjeto() {
      this.form = {
        nome: "",
        ativo: true,
      };
    },
  },
};
</script>
